import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Models } from '@ibexfusion/models';
import { ImportService } from '@services/imports/import.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DataTableComponent, DataTableEvent } from '../../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-import-types-detail',
    templateUrl: './import-types-detail.component.html',
    styleUrls: ['./import-types-detail.component.scss'],
    providers: [ImportService, ImportTypeService, DialogService],
    standalone: false
})
export class ImportTypesDetailComponent implements OnInit {

  public title = 'Loading';

  public description = 'loading';

  public pageActions: PageAction[];

  public importTypeId: string;

  public columns = [
    { prop: 'title', name: 'Title' },
    { prop: 'entryCount', name: 'Entries' },
    { prop: 'menuItemCount', name: 'Menu Items' },
    { prop: 'filterCount', name: 'Filters' },
    { prop: 'fileCount', name: 'Files' },
    {
      prop: 'autoUpdateInterval', name: 'Interval', valueTransformer: function(data) {
        return data / 1000 / 60 + ' min'
      }
    },
    {
      prop: 'wasLastSuccessful', name: 'Last Import Result', valueTransformer: function(data) {
        return data ? 'Success' : 'Error';
      }
    }
  ];

  public searchColumns = [{ prop: 'title' }];

  public boundImportType: Models.ImportType;

  @ViewChild('importTable') importTable: DataTableComponent;

  public params: any;

  constructor(
    public importService: ImportService,
    public importTypeService: ImportTypeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.importTypeId = this.activatedRoute.snapshot.params['id'];
    this.params = {
      typeId: this.importTypeId
    };
    return this.importTypeService.get(this.importTypeId).then(importType => {
      this.boundImportType = importType;
      this.title = 'Import Type: ' + importType.title;
      this.createPageActions();
    });
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['imports/', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['imports', event.row._id, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove importer?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.importService.remove(event.row._id).then(() => {
          this.importTable.refresh();
        });
      }).catch(error => {
      const message = (error.error.message ? error.error.message : error.message);
      return this.dialogService.confirm(message, error.name);
    });
  }

  private createPageActions(): void {
    this.pageActions = [new PageAction({
      icon: 'edit',
      title: 'Edit Type',
      callback: () => {
        this.router.navigate(['import-types/' + this.boundImportType._id + '/edit']);
      }
    }),
      new PageAction({
        icon: 'add',
        title: 'Create Import',
        callback: () => {
          this.router.navigate(['imports/create', this.boundImportType._id]);
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'Logs',
        callback: () => {
          this.router.navigate(['import-logs/', 'importTypeId', this.boundImportType._id]);
        }
      })];
  }
}
